// extracted by mini-css-extract-plugin
export default {"root":"ContainerImagesPage_root__0HM5T","image-results":"ContainerImagesPage_image-results__qesoP","fallback":"ContainerImagesPage_fallback__BBgcO"};